import { render, staticRenderFns } from "./Gs.vue?vue&type=template&id=59a801f4&scoped=true&"
import script from "./Gs.vue?vue&type=script&lang=js&"
export * from "./Gs.vue?vue&type=script&lang=js&"
import style0 from "./Gs.vue?vue&type=style&index=0&id=59a801f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a801f4",
  null
  
)

export default component.exports